// src/components/ProtectedRoute.jsx
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '../store/useAuthStore';

export function ProtectedRoute({ allowedRoles }) {
    const { isAuthenticated, user } = useAuthStore();

    if (!isAuthenticated) return <Navigate to="/login" replace />;

    if (user?.mustChangePassword && window.location.pathname !== '/change-password') {
        return <Navigate to="/change-password" replace />;
    }

    // Vérifie si l'utilisateur possède au moins l'un des rôles autorisés
    const hasAccess = allowedRoles
        ? user?.roles?.some(role => allowedRoles.includes(role))
        : true;

    if (!hasAccess) {
        // Redirige vers la page d'accueil (qui elle-même redirigera vers le bon dashboard)
        return <Navigate to="/connecter" replace />;
    }

    return <Outlet />;
}